module.exports = __webpack_public_path__ + "img/advantage_01.3f8122a0.png";